
import { createContext } from "react";

const BakingContext = createContext();

export default BakingContext;
